import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

type Role = { id: number; name: string; zone: string };

type GetRolesResponse = {
  roles: Role[];
};

export function getRoles(params = {}) {
  return axios.get<GetRolesResponse>('/api/v2/roles', { params });
}

export function useGetRoles(params = {}) {
  return useQuery({
    queryKey: ['roles', params],
    queryFn: () => getRoles(params).then(res => res.data)
  });
}

export function getClientAccountRoles(accountId: number) {
  return axios.get<Role[]>(`/api/v2/ca/accounts/${accountId}/roles`);
}

export function useGetClientAccountRoles(accountId: number) {
  return useQuery({
    queryKey: ['ca', 'accounts', accountId, 'roles'],
    queryFn: () => getClientAccountRoles(accountId).then(res => res.data)
  });
}

export function getUserRoles(id: number) {
  return axios.get(`/api/v2/users/${id}/roles`);
}

export function deleteUserRole(userId: number, roleId: number) {
  return axios.delete(`/api/v2/users/${userId}/roles/${roleId}`);
}

export function addUserRole(userId: number, roleId: number) {
  return axios.post(`/api/v2/users/${userId}/roles`, {
    user_role: {
      user_id: userId,
      role_id: roleId
    }
  });
}
